var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumbers2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 32H15.9999",
    stroke: "#0473FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 16H15.9999",
    stroke: "#0473FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 24H15.9999",
    stroke: "#0473FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 5.99983C8.00012 5.4694 8.21084 4.96069 8.58591 4.58562C8.96098 4.21055 9.46969 3.99983 10.0001 3.99983C10.4954 3.99711 10.9811 4.13588 11.4001 4.39983L13.2661 5.59983C13.6842 5.86699 14.17 6.00894 14.6661 6.00894C15.1623 6.00894 15.648 5.86699 16.0661 5.59983L17.9341 4.39983C18.3522 4.13268 18.838 3.99072 19.3341 3.99072C19.8303 3.99072 20.316 4.13268 20.7341 4.39983L22.6001 5.59983C23.0182 5.86699 23.504 6.00894 24.0001 6.00894C24.4963 6.00894 24.982 5.86699 25.4001 5.59983L27.2661 4.39983C27.6842 4.13268 28.17 3.99072 28.6661 3.99072C29.1623 3.99072 29.648 4.13268 30.0661 4.39983L31.9341 5.59983C32.3522 5.86699 32.838 6.00894 33.3341 6.00894C33.8303 6.00894 34.316 5.86699 34.7341 5.59983L36.6001 4.39983C37.0192 4.13588 37.5049 3.99711 38.0001 3.99983C38.5306 3.99983 39.0393 4.21055 39.4143 4.58562C39.7894 4.96069 40.0001 5.4694 40.0001 5.99983V41.9998C40.0001 42.5303 39.7894 43.039 39.4143 43.414C39.0393 43.7891 38.5306 43.9998 38.0001 43.9998C37.5049 44.0026 37.0192 43.8638 36.6001 43.5998L34.7341 42.3998C34.316 42.1327 33.8303 41.9907 33.3341 41.9907C32.838 41.9907 32.3522 42.1327 31.9341 42.3998L30.0661 43.5998C29.648 43.867 29.1623 44.0089 28.6661 44.0089C28.17 44.0089 27.6842 43.867 27.2661 43.5998L25.4001 42.3998C24.982 42.1327 24.4963 41.9907 24.0001 41.9907C23.504 41.9907 23.0182 42.1327 22.6001 42.3998L20.7341 43.5998C20.316 43.867 19.8303 44.0089 19.3341 44.0089C18.838 44.0089 18.3522 43.867 17.9341 43.5998L16.0661 42.3998C15.648 42.1327 15.1623 41.9907 14.6661 41.9907C14.17 41.9907 13.6842 42.1327 13.2661 42.3998L11.4001 43.5998C10.9811 43.8638 10.4954 44.0026 10.0001 43.9998C9.46969 43.9998 8.96098 43.7891 8.58591 43.414C8.21084 43.039 8.00012 42.5303 8.00012 41.9998V5.99983Z",
    stroke: "#0473FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbers2);
export default __webpack_public_path__ + "static/media/numbers-2.5fb38f169acb2c716abd6b012c5321dc.svg";
export { ForwardRef as ReactComponent };